import type {AdvertisementPreviewPlatform} from '@dms/api/sales';

export interface SharedAdvertisementPreviewValue<T> {
  value: T | null;
  isShared: boolean;
}

export interface AdvertisementPreviewSharedValues {
  mileage: SharedAdvertisementPreviewValue<number>;
}

function getSharedValue<T>(
  platforms: AdvertisementPreviewPlatform[],
  getValue: (platform: AdvertisementPreviewPlatform) => T | null
): SharedAdvertisementPreviewValue<T> {
  const firstValue = platforms[0] ? getValue(platforms[0]) : null;
  const isShared = platforms.every((platform) => Object.is(getValue(platform), firstValue));
  return {value: isShared ? firstValue : null, isShared};
}

export function getAdvertisementPreviewSharedValues(
  platforms: AdvertisementPreviewPlatform[]
): AdvertisementPreviewSharedValues {
  return {
    mileage: getSharedValue(platforms, (platform) => platform.mileage),
  };
}
